
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */

.button-bot {
  height: 2rem;
  width: 2rem;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.button-bot:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.button-max {
  height: 1.25rem;
  width: 1.25rem;
}

.chat-window {
  position: fixed;
  right: 1.25rem;
  z-index: 1000;
  display: none;
  height: 490px;
  width: 90%;
  flex-direction: column;
  background-color: var(--neutral-white);
  color: var(--blue-responsible-main);
  --tw-shadow: 0px 8px 32px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0px 8px 32px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

@media (min-width: 768px) {

  .chat-window {
    width: 510px;
  }
}

.chat-window.open {
  display: flex;
  border-radius: 0.5rem;
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-5);
  padding-top: 1.25rem;
  padding-bottom: 0.5rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-weight: var(--fw-bold);
  color: var(--neutral-white);
}

.chat-header button {
  cursor: pointer;
  border-style: none;
  background-color: var(--neutral-transparent);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  color: var(--neutral-white);
}

.chat-header-icon {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.chat-header-icon svg {
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-header-icon span {
  color: var(--blue-responsible-main);
}

.chat-header-icon .button-bot {
  height: 2.25rem;
  width: 2.25rem;
}

.legend {
  background-color: var(--blue-responsible-lighten-5);
  padding-top: 0.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 1rem;
}

.legend span:hover{
  border-bottom:1px solid;
}

.legend span a {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-style: italic;
  color: var(--blue-responsible-main);
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

.legend span a:hover {
  text-underline-offset: 8px;
}

.chat-body {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: var(--blue-responsible-lighten-5);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  overflow-y:scroll;
  overflow-anchor:none;
  scroll-behavior:auto;
  transform:translateZ(0);
}

.chat-body .aurora-bot {
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  align-self: flex-start;
  border-radius: 0.5rem;
  background-color: var(--neutral-transparent);
  padding: 0.5rem;
}

.chat-body .aurora-bot .icon-bot-message {
  display: grid;
  height: 1.5rem;
  width: 1.5rem;
  place-content: center;
  align-self: flex-start;
  justify-self: start;
  border-radius: 9999px;
  background-color: var(--blue-responsible-main);
}

.chat-body .aurora-bot .icon-bot-message svg {
  height: 1rem;
  width: 1rem;
  color: var(--neutral-white);
}

.chat-body .aurora-bot span.bot-message-content {
  min-width: 50px;
  max-width: 70%;
  overflow-wrap: break-word;
}

.chat-body .aurora-bot span img {
  height: 1rem;
  width: 1rem;
}

.chat-body .sendMessage {
  margin-bottom: 0.5rem;
  display: inline-block;
  min-width: 50px;
  max-width: 70%;
  align-self: flex-end;
  overflow-wrap: break-word;
  border-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-3);
  padding: 0.5rem;
}

.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem;
}

.dot {
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 9999px;
  background-color: var(--gray-cosmopolitan-main);
  opacity: 0.5;
  animation:bounce 1.4s infinite ease-in-out;
}

.dot:nth-child(1){
  animation-delay:-0.32s;
}

.dot:nth-child(2){
  animation-delay:-0.16s;
}

@keyframes bounce{
  0%, 80%, 100%{
    transform:translateY(0);
    opacity:0.5;
  }
  40%{
    transform:translateY(-6px);
    opacity:1;
  }
}

.chat-input {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  background-color: var(--blue-responsible-lighten-5);
  padding-top: 0.5rem;
  padding-bottom: 1rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.chat-input input {
  height: 50px;
  width: 83%;
  flex-grow: 1;
  border-radius: 0.375rem;
  border-style: none;
  padding: 0.25rem;
  text-indent: 0.25rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

@media (min-width: 768px) {

  .chat-input input {
    width: 88%;
  }
}

.chat-input span.counter {
  align-self: flex-end;
  font-size: var(--fs-xs);
  line-height: var(--lh-xs);
}

.chat-input input::-moz-placeholder {
  text-indent: 0.25rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.chat-input input::placeholder {
  text-indent: 0.25rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}

.chat-input button {
  position: absolute;
  right: 1.75rem;
  bottom: 2.9rem;
  display: grid;
  height: 35px;
  width: 35px;
  cursor: pointer;
  place-content: center;
  border-radius: 9999px;
  border-style: none;
  background-color: var(--blue-responsible-main);
  color: var(--neutral-white);
}

.chat-input button img {
  height: 17px;
  width: 17px;
}

.chat-window.maximized {
  position: fixed;
  top: 5rem;
  z-index: 50;
  height: 88%;
  width: 90%;
  border-radius: 0.5rem;
  --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1);
  --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (min-width: 768px) {

  .chat-window.maximized {
    width: 95%;
  }
}

@media (min-width: 1024px) {

  .chat-window.maximized {
    width: 95.8%;
  }
}

.chat-window.maximized .chat-input input {
  width: 100%;
  --tw-shadow: 0px 8px 32px rgba(0, 0, 0, 0.06);
  --tw-shadow-colored: 0px 8px 32px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.chat-header.maximized, .chat-window.maximized .chat-body, .chat-window.maximized .chat-input, .chat-window.maximized .legend {
  background-color: var(--neutral-white);
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.chat-header.maximized {
  padding-top: 2.25rem;
  padding-bottom: 1.5rem;
}

.chat-header.maximized .chat-header-icon span {
  color: var(--blue-responsible-darken-2);
}

.chat-window.maximized .chat-input {
  padding-bottom: 1.5rem;
  padding-top: 1.25rem;
}

.chat-window.maximized .legend {
  position: relative;
  display: block;
  padding-bottom: 1.25rem;
  padding-top: 1rem;
}

.chat-window.maximized .legend span {
  padding-left: 0px;
  padding-right: 0px;
}

.chat-window.maximized .legend::before{
  content:"";
  position: relative;
  top: -18px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 2px;
  background-color: var(--gray-cosmopolitan-lighten-1);
}

.chat-window.maximized .chat-header-icon span {
  padding: 0px;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
}

.chat-header.maximized .chat-header-button .button-max {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: transform;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.chat-window.maximized .chat-input button {
  right: 4rem;
  bottom: 3.3rem;
}

.hiddenElement {
  pointer-events: none;
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.float-buttom {
  position: fixed;
  right: 1rem;
  z-index: 1000;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

@media (min-width: 480px) {

  .float-buttom {
    right: 1.5rem;
  }
}

.aurora-chat-messages{
  transform:translateZ(0);
  contain:strict;
}
`;